import { showReceiptPdf } from "../receiptUtils.jsx"
import { fetchSignatureBlob } from "./fetchSignatureBlob.js"


function normalizeFileType(raw) {
    return String(raw ?? "").trim().toLowerCase()
}

function getFileUrlByType(order, type) {
    const files = Array.isArray(order?.files) ? order.files : []
    const match = files.find((f) => normalizeFileType(f?.type) === type)
    const url = match?.url ?? match?.URL ?? null
    return url ? String(url) : null
}

/**
 * v2 implementation mirrors v1 `OrderSummary.onPrintClick`.
 * @param {{ order: any, app: any }} args
 */
export async function viewPrintOrder({ order, app }) {
    if (!order) {
        return
    }
    const signatureUrl =
        getFileUrlByType(order, "signature") ??
        (order.signature_img ? `/static/${order.signature_img}` : null)

    const signatureBlob = await fetchSignatureBlob(signatureUrl, {
        orderId: order?.id,
        context: "viewPrintOrder",
    })
    await showReceiptPdf(
        order,
        order.master,
        app.locations,
        signatureBlob,
        app.species,
        app.options,
        app.weighInProcesses
    )
}

